import { z } from 'zod';

export const addAffiliateSchema = z.object({
    full_name: z.string().min(1, 'Name cannot be empty.').trim(),
    email: z.string().min(1, 'Email cannot be empty.').email('Enter a valid email address').trim(),
});

export type AddAffiliateFormData = z.infer<typeof addAffiliateSchema>;
